module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAGAAAABgCAMAAADVRocKAAAASFBMVEUAAAD////////////////////////////////////////////////////////////////////////////////////////////neHiwAAAAGHRSTlMAJIPH3/+/exgEi/v3c6OTMJvj50CrDNeNoElnAAAAu0lEQVR4Ae3N1WHEUBADQBlkZuy/0vDvOsm99aGmgcH9kihOUl4ozfICx8qqZpCmxZEyY7AOB3o6aGEa6KEpYBnpIoclpYsMFvpIfw1wIf5QoOCRAv5QoECBAgUKFChQoECBAgUKFChQYFMQbDKDmS4SM+joIjaDhR7qyAyw0kEFO9h2BsvKgwDbykB9CSP4sXQzL5aOA2AHLh41UKAgFCzz2UF3drCcHWA9O9h2p8AeVqfAtnRzeCB36R2NQD5C02TASgAAAABJRU5ErkJggg=="


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/copy-white-icon.png
// module id = 150
// module chunks = 0